<template>
<div>
    <el-select v-model="stage" placeholder="Please select stage" style="width:200px;" @change="handleSearch">
        <el-option v-for="option in stageOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
    </el-select>
    <el-table :data="paginationData" style="width:100%;max-height: auto;color:black;" empty-text="Loading data." fit>
        <el-table-column prop="enid" label="En_id"></el-table-column>
        <el-table-column prop="chr" label="Chr" width="80px"></el-table-column>
        <el-table-column prop="start" label="Start" width="110px"></el-table-column>
        <el-table-column prop="end" label="End" width="110px"></el-table-column>
        <el-table-column prop="width" label="width" width="80px"></el-table-column>
        <el-table-column prop="annotation" label="annotation"></el-table-column>
        <el-table-column prop="Species" label="Species" width="80px"></el-table-column>
        <el-table-column prop="Tissue" label="Tissue"></el-table-column>
    </el-table>
    <div class="pagination">
        <el-pagination
        :current-page="currentPageRange"
        :page-size="pageSize"
        :total="tableData.length"
        :page-count="pageCount"
        @current-change="handleCurrentChange"
        :background="true"
        layout="prev, pager, next"
        ></el-pagination>
    </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            records: [], // 查询结果数据
            currentPage: 1,
            pageSize: 10, // 设置每页显示的条数
            stage: '', 
            stageOptions: [
                { value: 'embryo', label: 'embryo' },
                { value: 'postnatal', label: 'postnatal' },
                { value: 'child', label: 'child' },],
            postnatalTissues: [
                "intestine postnatal (0 days)", "liver postnatal (0 days)", "midbrain postnatal (0 days)", "hindbrain postnatal (0 days)", "stomach postnatal (0 days)",
                "forebrain postnatal (0 days)", "lung postnatal (0 days)", "heart postnatal (0 days)", "kidney postnatal (0 days)"
            ],
            childTissues:[
                "right lobe of liver female child (16 years)", "heart left ventricle male child (3 years)", "left lung female child (16 years)", "small intestine male child (3 years)",
                "heart right ventricle male child (3 years)", "spleen male child (3 years)", "lung male child (3 years)", "stomach male child (3 years)", "psoas muscle male child (3 years)",
                "thymus male child (3 years)", "sigmoid colon male child (3 years)", "pancreas female child (16 years)"
            ],
            embryoTissues: [
            "0d_ESC","15d_primitive_cardiomyocite","2d_mesoderm","5d_cardiac_mesoderm","7d_cardiac_progenitor_cells","80d_ventricular_cardiomyocyte","stomach female embryo (96 days)",
            "thymus female embryo (110 days)", "chorionic villus male embryo (38 weeks)", "right lobe of liver female child (16 years)", "chorion male embryo (16 weeks)",
            "muscle of trunk female embryo (115 days)", "trophoblast female embryo (20 weeks)", "trophoblast female embryo (40 weeks)", 
            "placenta embryo (16 weeks)", "placental basal plate male embryo (38 weeks)", "left lung female child (16 years)", "placenta female embryo (113 days)",
            "placenta male embryo", "large intestine male embryo (108 days)", "chorion female embryo (40 weeks)", "placental basal plate female embryo (40 weeks)",
            "muscle of leg female embryo (110 days)",  "chorionic villus female embryo (40 weeks)", 
            "chorionic villus male embryo (16 weeks)", "adrenal gland male embryo (97 days)", "spleen male child (3 years)", "placenta male embryo (16 weeks)",
            "chorionic villus embryo (16 weeks)","amnion embryo (16 weeks)","spinal cord female embryo (108 days)","small intestine male embryo (108 days)",
            "2cell","8cell","CESC","CM","CP","liver embryo (14.5 days)r1","forebrain embryo (13.5 days)","forebrain embryo (10.5 days)","embryonic facial prominence embryo (12.5 days)",
            "lung embryo (16.5 days)","midbrain embryo (14.5 days)","kidney embryo (15.5 days)","hindbrain embryo (11.5 days)", "midbrain embryo (15.5 days)",
            "midbrain embryo (12.5 days)", "neural tube embryo (11.5 days)", "lung embryo (14.5 days)", "forebrain embryo (14.5 days)", "neural tube embryo (12.5 days)",
            "heart embryo (10.5 days)", "liver embryo (14.5 days)r2", "kidney embryo (14.5 days)", "limb embryo (15.5 days)", "hindbrain embryo (12.6 days)",
            "embryonic facial prominence embryo (10.5 days)", "heart embryo (14.5 days)r1",  "midbrain embryo (10.5 days)", "lung embryo (15.5 days)", "midbrain embryo (11.5 days)",
            "heart embryo (14.5 days)r2", "neural tube embryo (14.5 days)", "limb embryo (12.5 days)", "hindbrain embryo (10.5 days)", "neural tube embryo (15.5 days)",
            "limb embryo (10.5 days)", "limb embryo (13.5 days)", "stomach embryo (14.5 days)", "midbrain embryo (16.5 days)", "intestine embryo (15.5 days)",
            "neural tube embryo (13.5 days)", "forebrain embryo (11.5 days)", "limb embryo (14.5 days)", "hindbrain embryo (14.5 days)", "heart embryo (16.5 days)",
            "heart embryo (12.5 days)", "embryonic facial prominence embryo (13.5 days)", "embryonic facial prominence embryo (14.5 days)", "stomach embryo (16.5 days)",
            "midbrain embryo (13.5 days)", "heart embryo (15.5 days)", "forebrain embryo (12.5 days)", "embryonic facial prominence embryo (15.5 days)",
            "hindbrain embryo (13.5 days)", "limb embryo (11.5 days)", "forebrain embryo (15.5 days)", "embryonic facial prominence embryo (11.5 days)",
            "heart embryo (13.5 days)", "liver embryo (11.5 days)", "stomach embryo (15.5 days)", "liver embryo (13.5 days)", "intestine embryo (16.5 days)",
            "liver embryo (16.5 days)", "liver embryo (15.5 days)", "forebrain embryo (16.5 days)", "hindbrain embryo (15.5 days)", "intestine embryo (14.5 days)",
            "kidney embryo (16.5 days)", "hindbrain embryo (16.5 days)", "liver embryo (12.5 days)", "heart embryo (11.5 days)", "mESC", "MES", "oocytes", "Spermatids",
            "Spermatocytes", "Spermatogonia", "Thy1", "KIT", "PS", "RS", "hESC", "PreME", "ME", "hPGCLC", "hPGC", "DE" ,],
        };
    },
    computed: {
        tableData() {
            return this.records;
        },
        pageCount() {
            return Math.ceil(this.tableData.length / this.pageSize);
        },
        paginationData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.tableData.slice(start, end);
        },
        currentPageRange() {
            return Math.max(1, Math.min(this.currentPage, this.pageCount));
        },
    },
    mounted() {
        this.stage = 'postnatal'; // 设置默认阶段为 'postnatal'
        this.handleSearch();
    },
    methods: {
        handleSearch() {
            // 根据当前选择的阶段设置对应的组织数据
            let selectedTissues = [];
            if (this.stage === 'postnatal') {
                selectedTissues = this.postnatalTissues;
            } else if (this.stage === 'child') {
                selectedTissues = this.childTissues;
            } else if (this.stage === 'embryo') {
                selectedTissues = this.embryoTissues;
            }
            const params = {
                Tissue: selectedTissues,
            };
            this.$axios
                .get(this.url + "individual" + "/", { params })
                .then((response) => {
                this.records = response.data;
                })
                .catch((error) => {
                console.log(error);
                this.$message.error("Failed to fetch data.");
                });
        },
        handleCurrentChange(page) {
            // 处理分页组件的当前页变化事件
            this.currentPage = page;
        },
        exportCsv() {
            const header = ["En_id", "Chromsome", "Start", "End", "width", "annotation", "Species", "Tissue"]; // 如果换别的数据，注意换表头
            // 如果换别的数据，注意换内容,对应prop
            const data = this.tableData.map((row) => ({
                En_id: row.Coreid,
                Chromsome: row.Chr,
                Start: row.Testart,
                End: row.End,
                annotation: row.annotation,
                width: row.width,
                Species: row.Species,
                Tissue: row.Tissue,
            }));
            const csv = [header.join(","), ...data.map((row) => Object.values(row).join(","))].join("\n");
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "list.csv"); // 输出文件的名字
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

<style scoped>
.pagination {
text-align: center;
margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Stagelist.vue